module.exports = __webpack_public_path__ + "static/domiciliacion-68d4b31098a2a2e397f23071d49626b2.png";